<div class="flex flex-col h-full">
  
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
        Dashboard KSeF
      </h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
        Statystyki wysyłek batch do systemu KSeF
      </p>
    </div>
    <button 
      mat-flat-button 
      color="primary"
      (click)="refresh()"
      [disabled]="isLoading">
      <mat-icon [svgIcon]="'tabler_outline:refresh'"></mat-icon>
      Odśwież
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-12">
    <mat-spinner [diameter]="60"></mat-spinner>
    <p class="text-gray-600 dark:text-gray-400 mt-4">Ładowanie statystyk...</p>
  </div>

  <!-- Stats Cards -->
  <div *ngIf="!isLoading && stats" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">
    
    <!-- Connected Users -->
    <div class="stat-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 transition-all hover:shadow-lg hover:-translate-y-1">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-medium text-gray-600 dark:text-gray-400">Podłączeni</h3>
        <mat-icon class="text-indigo-500" [svgIcon]="'tabler_outline:users'"></mat-icon>
      </div>
      <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
        {{ stats.connectedUsers || 0 }}
      </div>
      <div class="text-xs text-gray-500 dark:text-gray-400">
        użytkowników z aktywnym KSeF
      </div>
    </div>
    
    <!-- Today Stats -->
    <div class="stat-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 transition-all hover:shadow-lg hover:-translate-y-1">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-medium text-gray-600 dark:text-gray-400">Dzisiaj</h3>
        <mat-icon class="text-blue-500" [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
      </div>
      <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
        {{ stats.today?.sent || 0 }}
      </div>
      <div class="flex items-center gap-4 text-sm">
        <span class="text-green-600 dark:text-green-400">✓ {{ stats.today?.success || 0 }}</span>
        <span class="text-red-600 dark:text-red-400">✗ {{ stats.today?.failed || 0 }}</span>
      </div>
      <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
        Sukces: {{ stats.today?.successRate || '0%' }}
      </div>
    </div>

    <!-- Last 7 Days -->
    <div class="stat-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 transition-all hover:shadow-lg hover:-translate-y-1">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-medium text-gray-600 dark:text-gray-400">Ostatnie 7 dni</h3>
        <mat-icon class="text-purple-500" [svgIcon]="'tabler_outline:calendar-week'"></mat-icon>
      </div>
      <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
        {{ stats.last7Days?.sent || 0 }}
      </div>
      <div class="flex items-center gap-4 text-sm">
        <span class="text-green-600 dark:text-green-400">✓ {{ stats.last7Days?.success || 0 }}</span>
        <span class="text-red-600 dark:text-red-400">✗ {{ stats.last7Days?.failed || 0 }}</span>
      </div>
      <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
        Sukces: {{ stats.last7Days?.successRate || '0%' }}
      </div>
    </div>

    <!-- Last 30 Days -->
    <div class="stat-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 transition-all hover:shadow-lg hover:-translate-y-1">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-medium text-gray-600 dark:text-gray-400">Ostatnie 30 dni</h3>
        <mat-icon class="text-green-500" [svgIcon]="'tabler_outline:calendar-month'"></mat-icon>
      </div>
      <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
        {{ stats.last30Days?.sent || 0 }}
      </div>
      <div class="flex items-center gap-4 text-sm">
        <span class="text-green-600 dark:text-green-400">✓ {{ stats.last30Days?.success || 0 }}</span>
        <span class="text-red-600 dark:text-red-400">✗ {{ stats.last30Days?.failed || 0 }}</span>
      </div>
      <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
        Sukces: {{ stats.last30Days?.successRate || '0%' }}
      </div>
    </div>

    <!-- Processing Time -->
    <div class="stat-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 transition-all hover:shadow-lg hover:-translate-y-1">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-medium text-gray-600 dark:text-gray-400">Czas przetwarzania</h3>
        <mat-icon class="text-orange-500" [svgIcon]="'tabler_outline:clock'"></mat-icon>
      </div>
      <div class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        {{ stats.today?.avgProcessingTime || '-' }}
      </div>
      <div class="text-xs text-gray-500 dark:text-gray-400 space-y-1">
        <div>Min: {{ stats.today?.minProcessingTime || '-' }}</div>
        <div>Max: {{ stats.today?.maxProcessingTime || '-' }}</div>
      </div>
    </div>
  </div>

  <!-- Hourly Chart Placeholder -->
  <div *ngIf="!isLoading && stats" class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
    <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
      Wysyłki per godzina (dzisiaj)
    </h3>
    <div class="flex items-center justify-center h-64 bg-gray-50 dark:bg-gray-900 rounded-lg">
      <div class="text-center text-gray-500 dark:text-gray-400">
        <mat-icon [svgIcon]="'tabler_outline:chart-line'" class="mb-2" style="width: 48px; height: 48px; font-size: 48px;"></mat-icon>
        <p>Wykres będzie dostępny wkrótce</p>
        <p class="text-xs mt-1">Dane: {{ (stats.byHour || []).length }} godzin</p>
      </div>
    </div>
  </div>
</div>

